module.exports = __webpack_public_path__ + "static/media/SPI_Blue.7d95162b.jpg";